import { useEffect, useRef } from 'react';

const useInterval = (callback, ms = 1000) => {
  const interval = useRef();

  const callbackRef = useRef(callback);

  useEffect(() => {
    interval.current = setInterval(() => {
      if (callbackRef.current) {
        callbackRef.current(() => {
          clearInterval(interval.current);
        });
      }
    }, ms);

    return () => {
      clearInterval(interval.current);
    };
  }, [ms]);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);
};

export default useInterval;
